<template>
    <div id="otpSetting">
        <form @submit.prevent="saveOtpSetting" ref="formOtpSetting" >
        <div class="card-header">
            <div class="row">
                <div class="col-6"><h3>Otp Setting</h3></div>
                <div class="col-6 text-right">
                    <button type="submit" class="btn btn-success btn-md" :disabled="isLoading" >Save</button>
                    <button type="button" class="btn btn-light btn-md" @click="$parent.close">Cancel</button>
                </div>
            </div>
        </div>
        <div v-if="isLoading"><Loader></Loader></div>
            <div class="card-body" v-else>
                <div class="alert alert-dark" role="alert">
                    <b>Info: </b> Contact information for linking devices when authorizing an event. <br />
                    If you leave this section blank, the organization's data is taken as a basis.<br />
                    Write the phone number, do not use characters, symbols or spaces,<br /> Ex: 7745551234
                </div>
                <div class="form-group">
                    <label for="phoneNumber">Phone Number1: <small>(Required)</small></label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="phone1" id="phoneNumber" style="font-size: 20px" placeholder="7745551234" required>
                    </div>
                </div>
                <div class="form-group">
                    <label for="phoneNumber2">Phone Number2: <small>(Optional)</small></label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="phone2" id="phoneNumber2" style="font-size: 20px" placeholder="7745551234" >
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">Email: <small>(Required)</small></label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control" v-model="email" id="email" style="font-size: 20px" placeholder="alex@domain.com" required>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader.vue";
export default {
    name: "otpSetting",
    components: {
        Loader,
    },
    data() {
        return {
			// @ts-ignore
			org_id: window.localorgdata,
			// @ts-ignore
			user_id: window.master_client,
            isLoading: false,
            phone1: null,
            phone2: null,
            email: null,
        };
    },
    created() {
        this.getOtpSetting();
    },
    methods: {
        getOtpSetting(){
			let t = this;
			t.isLoading = true;
				// @ts-ignore
			window.master.post('bRem/getOtpSetting', {
				org_id: this.org_id,
				user_id: this.user_id,
			})
			.then((response) => {
				t.isLoading = false;
				console.log('bRem loaded', response.data);
                if(response.data.otpSetting){
                    this.phone1 = response.data.otpSetting.phone1;
                    this.phone2 = response.data.otpSetting.phone2;
                    this.email = response.data.otpSetting.email;
                }
			}).catch((error) => {
				t.isLoading = false;
				console.log(error);
                this.$store.commit('core/setNotiPush', {
                    show: true,
                    group: "notiPush",
                    type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Error',
                    text: error.message ?? 'Server error.',
                    duration: 5000
                });
			});
        },
        clickSave(){
            this.$refs.formOtpSetting.dispatchEvent(new Event('submit', { cancelable: true }));
        },
        saveOtpSetting(){
			let t = this;
			t.isLoading = true;
				// @ts-ignore
			window.master.post('bRem/setOtpSetting', {
				org_id: this.org_id,
				user_id: this.user_id,
				phone1: this.phone1,
				phone2: this.phone2,
				email: this.email,
			})
			.then((response) => {
				t.isLoading = false;
				console.log('bRem loaded', response.data);
                if(response.data.success){
                    this.$parent.close();
                }else {
                    this.$store.commit('core/setNotiPush', {
                        show: true,
                        group: "notiPush",
                        type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                        title: 'Error',
                        text: response.data.message,
                        duration: 15000
                    });
                }
			}).catch((error) => {
				t.isLoading = false;
				console.log(error);
                this.$store.commit('core/setNotiPush', {
                    show: true,
                    group: "notiPush",
                    type: '3', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Error',
                    text: error.message ?? 'Server error.',
                    duration: 15000
                });
			});
        }
    }
};
</script>
<style lang="scss" scoped>
#otpSetting {
    .card-header{
        padding-top: 10px;
        padding-bottom:5px;
    }
    .card-body {
        height: 400px;
        overflow: hidden;
        overflow-y: auto;
        padding-bottom:50px;
        padding-top: 5px;
    }
    .btn-light {background: #fff; border: 1px solid #ccc; margin-left:25px;}
}
</style>
